import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=64231951&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"
import style0 from "./Reports.vue?vue&type=style&index=0&id=64231951&prod&scoped=true&lang=css"
import style1 from "./Reports.vue?vue&type=style&index=1&id=64231951&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64231951",
  null
  
)

export default component.exports